import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft } from "@tabler/icons-react";
import { AdminPageHeader, Button, Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import { FlujosTab } from "./flujos/FlujosTab";
import { BitacoraTab } from "./bitacora/BitacoraTab";

/**
 * `/admin/notificaciones` · flujos (qué se notifica al ocurrir cada evento) y bitácora de
 * envíos. El diseñador de cada flujo vive en `/admin/notificaciones/$id`.
 */
export function AdminNotificacionesPage() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <AdminPageHeader
        title="Notificaciones"
        description="Liga eventos del portal con correos, webhooks y avisos en campana. Los cambios se editan en borrador y aplican al publicar."
        actions={
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
        }
      />
      <Tabs defaultValue="flujos">
        <TabsList className="mb-4">
          <TabsTrigger value="flujos">Flujos</TabsTrigger>
          <TabsTrigger value="bitacora">Bitácora de envíos</TabsTrigger>
        </TabsList>
        <TabsContent value="flujos">
          <FlujosTab />
        </TabsContent>
        <TabsContent value="bitacora">
          <BitacoraTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
